import { createSlice } from "@reduxjs/toolkit";
import {
  fetchLeaguePages,
  fetchleaguePresentation,
  fetchleagueTournaments,
  fetchSparcRule,
} from "../action/getStartAction";

const initialState = {
  isLoading: false,
  leagueData: {},
  leagueTournamentsData: {},
  leaguePresentationData: [],
  selectedPresentation: {},
  sparcRuleList: [],
};

export const getStartSlice = createSlice({
  name: "home",
  initialState: initialState,
  reducers: {
    setSeletectedPresentation: (state, action) => {
      state.selectedPresentation = action?.payload;
    },
  },
  extraReducers: (builder) => {
    // fetch-league
    builder.addCase(fetchLeaguePages.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.leagueData = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchLeaguePages.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchLeaguePages.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-league
    builder.addCase(fetchleagueTournaments.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.leagueTournamentsData = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchleagueTournaments.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchleagueTournaments.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-league
    builder.addCase(fetchleaguePresentation.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.selectedPresentation = data?.length > 0 ? data[0] : {};
      state.leaguePresentationData = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchleaguePresentation.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchleaguePresentation.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-league
    builder.addCase(fetchSparcRule.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.sparcRuleList = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchSparcRule.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchSparcRule.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export const { setSeletectedPresentation } = getStartSlice.actions;
export default getStartSlice.reducer;
